// extracted by mini-css-extract-plugin
export default {"block":"JobInfo_block__4X3-C","header":"JobInfo_header__GeChR","titleBlock":"JobInfo_titleBlock__t-qVr","subHeader":"JobInfo_subHeader__lXr6M"};